module.exports = {
  v: '2.3.1'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/pingpp-js/src/version.js
// module id = Tysu
// module chunks = 5